import { createFileRoute } from '@tanstack/react-router';
import { MeetGuestPage } from '@/features/public/components/MeetGuestPage';

/** Public individual session; no agent authentication or private bootstrap. */
export const Route = createFileRoute('/meet/$token')({
  component: MeetRouteComponent,
});

// eslint-disable-next-line react-refresh/only-export-components
function MeetRouteComponent() {
  const { token } = Route.useParams();
  return <MeetGuestPage token={token} />;
}
